<template>
  <span v-show="showLabel" class="environmentVersion">{{ applicationConfiguration }} Version </span>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'environment',
  computed: {
    ...mapGetters({
      applicationConfiguration: 'app/applicationConfiguration',
    }),
    showLabel() {
      return this.applicationConfiguration != '' && this.applicationConfiguration != 'Prod'
    },
  },
}
</script>

<style scoped>
.environmentVersion {
  position: fixed;
  left: 50%;
  color: #960322;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  background-color: rgba(251, 189, 20, 0.82);
  border: solid #960322 1px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  box-shadow: #999 1px 1px 8px 0px;
  padding: 1px 32px;
  z-index: 5;
}
</style>
